import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Button, Typography } from '@mui/material';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import React from 'react';
import { ResponseError } from 'superagent';

import { SnackbarCloseButton } from './SnackbarCloseButton';
import { getQueryErrorMessage } from 'utils/httpError';

interface Props {
  errorMessageGetter?: (error: unknown, fallbackMessage?: string) => string;
}

const defaultErrorMessageGetter = (error: unknown, fallbackMessage = 'Request failed. Please try again.') =>
  getQueryErrorMessage(error, fallbackMessage);

export const useErrorSnackbarWithRetry = ({ errorMessageGetter = defaultErrorMessageGetter }: Props = {}) => {
  const enqueueErrorSnackbar = (error: ResponseError, actionDescription: string, retryFunc?: () => void) =>
    enqueueSnackbar(
      <Accordion
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          backgroundImage: 'none',
          color: 'white',
          width: '20vw',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon data-cy="expand-button" sx={{ color: 'white' }} />}
          sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}
        >
          <Typography variant="body1">Failed to {actionDescription}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {errorMessageGetter(error, `Failed to ${actionDescription}. Please try again.`)}
        </AccordionDetails>
      </Accordion>,
      {
        variant: 'error',
        action: (key) =>
          retryFunc ? (
            <Button
              disabled={!retryFunc}
              color="primary"
              onClick={() => {
                closeSnackbar(key);
                retryFunc();
              }}
            >
              Try again
            </Button>
          ) : (
            <SnackbarCloseButton snackbarKey={key} />
          ),
      }
    );

  return { enqueueErrorSnackbar };
};
